
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-sale/[typeAndCity]",
      function () {
        return require("private-next-pages/for-sale/[typeAndCity]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-sale/[typeAndCity]"])
      });
    }
  